import { useMemo } from 'react';

import { EMPTY_OBJECT } from '../../../constants';
import { useThemeContext } from '../../theme/context/ThemeContext';
import { IconTheme } from '../types';

export const useIconTheme = (theme: Partial<IconTheme> = EMPTY_OBJECT): IconTheme => {
  const {
    theme: { icon },
  } = useThemeContext();

  return useMemo(() => ({ ...icon, ...theme }), [icon, theme]);
};
